/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import Button from "uis/Button";
import Modal from "react-modal";
import { theme } from "styles/theme";
import { TVisitor } from "apis/visitors/type";
import { useEffect } from "react";

const modalStyle = {
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        width: "500px",
        borderRadius: "20px",
        transform: "translate(-50%, -50%)",
    },
    overlay: {
        backgroundColor: "var(--component-color-material-dimmer)",
        zIndex: 1,
    },
};

Modal.setAppElement("#root");

const Content = styled.p`
    color: ${theme.neutral600};
    font-size: 20px;
    font-weight: 400;
    text-align: center;
    line-height: 25px;
`;

const Title = styled.p`
    font-size: 24px;
    font-weight: 700;
    text-align: center;
    margin-bottom: 12px;
    margin-top: 24px;
`;

const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 40px 30px;
`;

const IconContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 64px;
    height: 64px;
    border-radius: 50px;
    background-color: ${theme.primary50};
`;

type Props = {
    modalIsOpen: boolean;
    onHandleBtn?: () => void;
    sendVisitors?: TVisitor[];
};

const SuccessSendMessage = (props: Props) => {
    const { modalIsOpen, onHandleBtn, sendVisitors } = props;

    useEffect(() => {}, [sendVisitors]);

    return (
        <Modal isOpen={modalIsOpen} onRequestClose={() => {}} style={modalStyle}>
            <Container>
                <IconContainer>
                    <CircleCheckIcon />
                </IconContainer>
                <Title>방문 상세 안내 메세지 전송 완료</Title>
                <Content>방문 등록한 {sendVisitors?.length.toString()}명에게 상세안내 메시지가 전송되었습니다.</Content>
                <Button
                    onClick={onHandleBtn}
                    title="확인"
                    styles={{
                        container: css`
                            width: 80%;
                            padding: 16px;
                            margin-top: 36px;
                        `,
                    }}
                />
            </Container>
        </Modal>
    );
};

export default SuccessSendMessage;

const CircleCheckIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="41" height="40" viewBox="0 0 41 40" fill="none">
            <g clip-path="url(#clip0_2475_46)">
                <path
                    d="M20.5 3.75C24.8098 3.75 28.943 5.46205 31.9905 8.50951C35.038 11.557 36.75 15.6902 36.75 20C36.75 24.3098 35.038 28.443 31.9905 31.4905C28.943 34.538 24.8098 36.25 20.5 36.25C16.1902 36.25 12.057 34.538 9.00951 31.4905C5.96205 28.443 4.25 24.3098 4.25 20C4.25 15.6902 5.96205 11.557 9.00951 8.50951C12.057 5.46205 16.1902 3.75 20.5 3.75ZM20.5 40C25.8043 40 30.8914 37.8929 34.6421 34.1421C38.3929 30.3914 40.5 25.3043 40.5 20C40.5 14.6957 38.3929 9.60859 34.6421 5.85786C30.8914 2.10714 25.8043 0 20.5 0C15.1957 0 10.1086 2.10714 6.35786 5.85786C2.60714 9.60859 0.5 14.6957 0.5 20C0.5 25.3043 2.60714 30.3914 6.35786 34.1421C10.1086 37.8929 15.1957 40 20.5 40ZM29.3281 16.3281C30.0625 15.5938 30.0625 14.4063 29.3281 13.6797C28.5938 12.9531 27.4062 12.9453 26.6797 13.6797L18.0078 22.3516L14.3359 18.6797C13.6016 17.9453 12.4141 17.9453 11.6875 18.6797C10.9609 19.4141 10.9531 20.6016 11.6875 21.3281L16.6875 26.3281C17.4219 27.0625 18.6094 27.0625 19.3359 26.3281L29.3281 16.3281Z"
                    fill="#3885FF"
                />
            </g>
            <defs>
                <clipPath id="clip0_2475_46">
                    <rect width="40" height="40" fill="white" transform="translate(0.5)" />
                </clipPath>
            </defs>
        </svg>
    );
};
